// client/src/pages/TermsOfServicePage.jsx
//
// Public-facing Terms of Service page. Anyone can read without logging in.
// Accessible at /terms

import { BRAND } from '../config/brand';

export default function TermsOfServicePage() {
  const G = BRAND.colors.primary;
  
  return (
    <div style={{
      minHeight: '100vh',
      background: '#F8FAFC',
      padding: '48px 24px',
      fontFamily: "'DM Sans', system-ui, sans-serif",
    }}>
      <div style={{
        maxWidth: 800,
        margin: '0 auto',
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #E2E8F0',
        padding: '48px',
      }}>
        {/* Header */}
        <div style={{ marginBottom: 48 }}>
          <div style={{
            fontSize: 12,
            fontWeight: 600,
            color: G,
            letterSpacing: '1.2px',
            textTransform: 'uppercase',
            marginBottom: 12,
          }}>
            Legal
          </div>
          <h1 style={{
            fontSize: 36,
            fontWeight: 700,
            color: '#0F172A',
            marginBottom: 16,
            letterSpacing: '-0.5px',
          }}>
            Terms of Service
          </h1>
          <p style={{
            fontSize: 14,
            color: '#64748B',
            marginBottom: 0,
          }}>
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div style={{
          fontSize: 14,
          lineHeight: 1.8,
          color: '#475569',
        }}>
          {/* Section 1 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing and using PromoMerge (the "Service"), you agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you do not agree to these Terms, please do not use the Service.
          </p>

          {/* Section 2 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            2. Use License
          </h2>
          <p>
            PromoMerge grants you a limited, non-exclusive, non-transferable license to use the Service for your promotional products business. You may not resell, redistribute, or use the Service on behalf of third parties without prior written authorization from PromoMerge.
          </p>

          {/* Section 3 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            3. Payment and Billing
          </h2>
          <p>
            You agree to pay all subscription fees associated with your chosen plan. Subscription plans renew automatically on the date specified during signup. You are responsible for all charges incurred under your account. You may cancel your subscription at any time through your account settings, and cancellation will take effect at the end of your current billing cycle.
          </p>

          {/* Section 4 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            4. Stripe Payment Processing
          </h2>
          <p>
            PromoMerge uses Stripe to process payments for invoice collection and subscription billing. When you use these features, your payment information is transmitted to and processed by Stripe in accordance with Stripe's terms of service and privacy policy. By using PromoMerge, you agree to Stripe's terms and conditions. PromoMerge does not store complete payment card information on our servers.
          </p>

          {/* Section 5 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            5. User Responsibilities
          </h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to:
          </p>
          <ul style={{
            marginLeft: 20,
            marginBottom: 16,
          }}>
            <li>Provide accurate and complete information</li>
            <li>Use the Service only for lawful purposes</li>
            <li>Not impersonate any person or entity</li>
            <li>Not interfere with the operation of the Service</li>
            <li>Not attempt to gain unauthorized access to the Service</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>

          {/* Section 6 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            6. Intellectual Property
          </h2>
          <p>
            All content, features, and functionality of PromoMerge (including but not limited to software, designs, and documentation) are the exclusive property of PromoMerge and its licensors. You may not reproduce, distribute, or transmit any content without our prior written permission.
          </p>

          {/* Section 7 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            7. Limitation of Liability
          </h2>
          <p>
            To the fullest extent permitted by law, PromoMerge is provided "as is" without any warranties, express or implied. PromoMerge shall not be liable for:
          </p>
          <ul style={{
            marginLeft: 20,
            marginBottom: 16,
          }}>
            <li>Indirect, incidental, special, or consequential damages</li>
            <li>Loss of data, revenue, or business opportunity</li>
            <li>Unauthorized access to or alteration of your data</li>
            <li>Third-party actions or content</li>
          </ul>

          {/* Section 8 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            8. Termination
          </h2>
          <p>
            PromoMerge reserves the right to terminate or suspend your account at any time for violation of these Terms or for any reason at our sole discretion. Upon termination, your right to use the Service will immediately cease.
          </p>

          {/* Section 9 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            9. Changes to Terms
          </h2>
          <p>
            PromoMerge reserves the right to modify these Terms at any time. Changes will be effective immediately upon posting to the Service. Your continued use of the Service following the posting of revised Terms means that you accept and agree to the changes.
          </p>

          {/* Section 10 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            10. Governing Law
          </h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of Washington, without regard to its conflict of law provisions.
          </p>

          {/* Section 11 */}
          <h2 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#0F172A',
            marginTop: 32,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `2px solid ${G}22`,
          }}>
            11. Contact Us
          </h2>
          <p>
            If you have any questions about these Terms, please contact us at support@promosearch.io.
          </p>

          {/* Footer spacer */}
          <div style={{ marginTop: 48 }} />
        </div>
      </div>
    </div>
  );
}
